import { useQuery } from '@tanstack/react-query';
import { MarkdownImageCollection } from 'src/company/templates/hooks/useConvertToMarkdownMutation';

type useMarkdownImageCollectionProps = {
  companyId: string;
  collectionId: string;
  enabled?: boolean;
};

export const useMarkdownImageCollection = ({
  companyId,
  collectionId,
  enabled = true,
}: useMarkdownImageCollectionProps) => {
  const { data, isLoading, isError, error, isFetched } = useQuery<MarkdownImageCollection>({
    queryKey: ['admin', 'companies', companyId, 'markdown-image-collections', collectionId],
    enabled,
  });

  return {
    collection: data,
    isLoading,
    isError,
    isFetched,
    error,
  };
};
